import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/screens/Welcome'
import SelectRestaurant from '@/screens/sessions/SelectRestaurant'
import SelectProvider from '@/screens/sessions/SelectProvider'
import sessions from './sessions'
import purchase from './purchase'
import finances from './finances'
import people from './people'
import clients from './clients'
import settings from './settings'
import errors from './errors'
import sales from './sales'
import balance from './balance'
import provider from './provider'
import reports from './reports'
import recipes from './recipes'
import production from './production'
import menu from './menu'
import restaurants from './restaurants'
import warehouse from './warehouse'
import issues from './issues'
import userSupport from './userSupport'
import OrderViewer from '@/screens/purchaseOrders/OrderViewer'
import expenses from './expenses'
import income from './income'
import movements from './movements'
import decreases from './decreases'
import accounting from './accounting'
import myRestaurants from './my-restaurants'
import systemPreference from './systemPreference'
import profileUser from './profileUser'
import management from './management'

import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      beforeEnter: async (to, from, next) => {
        if (store.state.login.role && store.state.login.token) {
          if (store.state.currentProvider.data._id) {
            return next({ name: 'ProviderInbox' })
          }
          if (store.state.currentRestaurant.data._id) {
            const urls = {
              manager: 'Recipes',
              stockmanager: 'CaptureInventory',
              chef: 'Recipes',
              buyer: 'Dishes',
              sales: 'Sales'
            }
            return next({ name: urls[store.state.login.role] })
          }
          await store.dispatch('login/loadLoginData')
          if (store.state.userProvider) {
            return next({ name: 'SelectProvider' })
          } else {
            return next({ name: 'SelectRestaurant' })
          }
        }
        return next('/login')
      }
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
      meta: { requireAuth: false }
    },
    {
      path: '/select-restaurant',
      name: 'SelectRestaurant',
      component: SelectRestaurant,
      meta: { requireAuth: false }
    },
    {
      path: '/select-provider',
      name: 'SelectProvider',
      component: SelectProvider,
      meta: { requireAuth: false }
    },
    {
      path: '/order-viewer/:id',
      name: 'OrderViewer',
      component: OrderViewer
    },
    ...sessions,
    ...recipes,
    ...production,
    ...menu,
    ...purchase,
    ...finances,
    ...people,
    ...clients,
    ...settings,
    ...sales,
    ...errors,
    ...balance,
    ...provider,
    ...reports,
    ...restaurants,
    ...warehouse,
    ...issues,
    ...provider,
    ...userSupport,
    ...expenses,
    ...income,
    ...movements,
    ...decreases,
    ...accounting,
    ...myRestaurants,
    ...systemPreference,
    ...profileUser,
    ...management
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

let loaded = false

router.beforeEach(async (to, from, next) => {
  if (window.performance.navigation.type === 0 && !loaded) {
    await store.dispatch('login/resetLogin')
    loaded = true
  }

  if (to.meta.requireAuth) {
    if (store.state.login.token === null) {
      next({ name: 'Login' })
    } else {
      if (!store.state.currentRestaurant.data._id && !store.state.currentProvider.data._id) {
        await store.dispatch('login/loadLoginData')
        if (store.state.userProvider) {
          next({ name: 'SelectProvider' })
        } else {
          next({ name: 'SelectRestaurant' })
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }

  if (to.meta.middleware) {
    const middleware = to.meta.middleware
    const role = to.meta.permissions
    const context = { from, to, next, store, role }
    return middleware.auth({ ...context })
  }

  loaded = true
})

export default router
